'use client';

import { createContext, useContext } from 'react';
import type { NatsConnection } from 'nats.ws';
import type { SocketManagerProviderConfig } from '../types';

// ============================================
// Context Value Type
// ============================================

export interface SocketManagerContextValue {
  // Connection states
  pricesConnection: WebSocket | null;
  tradesConnection: WebSocket | null;
  usPricesConnection: WebSocket | null;
  natsConnection: NatsConnection | null;

  // Connection status
  isPricesConnected: boolean;
  isTradesConnected: boolean;
  isUSPricesConnected: boolean;
  isNatsConnected: boolean;

  // Config
  config: SocketManagerProviderConfig;
}

// ============================================
// Context
// ============================================

const defaultContextValue: SocketManagerContextValue = {
  pricesConnection: null,
  tradesConnection: null,
  usPricesConnection: null,
  natsConnection: null,
  isPricesConnected: false,
  isTradesConnected: false,
  isUSPricesConnected: false,
  isNatsConnected: false,
  config: {},
};

export const SocketManagerContext =
  createContext<SocketManagerContextValue>(defaultContextValue);

// ============================================
// Hook to access context
// ============================================

export function useSocketManagerContext(): SocketManagerContextValue {
  const context = useContext(SocketManagerContext);
  if (!context) {
    throw new Error(
      'useSocketManagerContext must be used within a SocketManagerProvider',
    );
  }
  return context;
}
